
import Vue from 'vue';
import SkeletonLoader from '@root/common/components/base/loader/SkeletonLoader.vue';
import isMobileView from '@root/common/utils/isMobileView';

interface Computed {
  isMobileView: boolean;
}

export default Vue.extend<unknown, unknown, Computed, unknown>({
  components: {
    SkeletonLoader,
  },
  computed: {
    isMobileView() {
      return isMobileView();
    },
  },
});
